import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { concatMap, tap } from "rxjs/operators";

import { IotModel } from "app/shared/models/iot.model";
import { MedicationIncidentTopicNames } from "app/shared/models/iot.topics";
import { MedicationActions, PubsubModel } from "app/shared";

import { AdministrationMedicationIncidentModel } from "./administration-medication-incident-model.service";

@Injectable()
export class MedicationIncidentListener extends PubsubModel {
	private readonly iotModel = inject(IotModel);
	private readonly store = inject(Store);
	private readonly administrationMedicationIncidentModel = inject(AdministrationMedicationIncidentModel);

	override listen() {
		return this.syncCreateAdministrationMedicationIncident().subscribe();
	}

	private syncCreateAdministrationMedicationIncident() {
		return this.iotModel
			.subscribeWithOrganisationPrefix<{ id: string }>(MedicationIncidentTopicNames.MEDICATION_INCIDENT_CREATED)
			.pipe(
				concatMap((medicationIncidentData) =>
					this.administrationMedicationIncidentModel.getAdministrationMedicationIncident(medicationIncidentData.id),
				),
				tap((medicationIncident) => {
					this.store.dispatch(MedicationActions.createAdministrationMedicationIncidentIot(medicationIncident));
				}),
			);
	}
}
